
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    MARK_AS_RMA_GET_DEVICE_REQUEST,
    MARK_AS_RMA_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { markAsRmaGetDeviceResult, markAsRmaResult } from 'Redux/actions';


function* getDevice({ payload }) {
    try {
        const QUERY = `
        query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
            result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    label
                    esn
                    imei
                    isRMA
                    status
                    simCard {
                        iccId
                        msisdn
                        simProviderAccount {
                            id
                            name
                            simProviderId
                            simProvider {
                                id
                                name
                            }
                        }
                    }
                    deviceModel {
                        id
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                    }
                    refurbishedUnit { 
                        refurbishedUnitId 
                    }
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["esn", "imei"],
                    terms: [payload],
                    exact: true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(markAsRmaGetDeviceResult(data?.result))
        } else {
            yield put(markAsRmaGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(markAsRmaGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/markAsRma/redux/saga",
            "getDevice",
        )
    }
}

function* markAsRma({ payload }) {
    try {

        let QUERY = `
            mutation updateUnitsBatch ($unitIds: [Int]!, $features: UnitFeatureInput!, $status: Int, $reference: String) {
                result: updateUnitsBatch (unitIds: $unitIds, features: $features, status: $status, reference: $reference){
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate     
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(markAsRmaResult({ markAsRma: data?.result }))
        } else {
            yield put(markAsRmaResult({ markAsRma: false }))
        }

    } catch (exc) {
        yield put(markAsRmaResult({ markAsRma: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/markAsRma/redux/saga",
            "markAsRma",
        )
    }
}

function* watchMethods() {
    yield takeEvery(MARK_AS_RMA_GET_DEVICE_REQUEST, getDevice);
    yield takeEvery(MARK_AS_RMA_REQUEST, markAsRma);
}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}